<template>
    <div class="main">
        <div class="login">
            <el-form class="form" :model="form">
                <div class="login-title">{{ title }}登录</div>
                <el-form-item prop="loginName" class="inputCSS">
                    <el-input
                        class="inputPlaceholder"
                        type="text"
                        color="#fff"
                        v-model="form.account"
                        placeholder="请输入账号"
                        auto-complete="off"
                    ></el-input>
                </el-form-item>
                <el-form-item prop="password" class="inputCSS">
                    <el-input
                        class="inputPlaceholder"
                        type="password"
                        v-model="form.password"
                        placeholder="请输入登录密码"
                        auto-complete="off"
                    ></el-input>
                </el-form-item>
                <el-checkbox v-model="checked" class="checkBox">记住密码</el-checkbox>
                <el-form-item>
                    <button class="login_btn" width="100%" type="button" @click="login">登录</button>
                </el-form-item>
            </el-form>
        </div>
        <div class="copyright">Copyright © 2020 xiaode Systems Incorporated. All rights reserved.</div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            form: {
                account: "",
                password: "",
                app: "admin",
                terminal: "computer"
            },
            firmInfo: {
                id: 5,
            },
            checked: true,
        };
    },
    computed: {
        title() {
            return this.$store.state.websiteInfo.firmName || ''
        }
    },
    mounted() {
        // this.$router.push('/main/myMessage')
        if (localStorage.getItem("user")) {
            const user = JSON.parse(localStorage.getItem("user"))
            this.form.account = user.account
            this.form.password = user.password
        }
    },
    methods: {
        login() {
            this.ajax.post('/login', this.form).then(data => {
                this.$message({
                    type: 'success',
                    message: '操作成功！'
                })
                //data.firmInfo = this.firmInfo
                sessionStorage.setItem('session', JSON.stringify(data))
                if (this.checked) {
                    localStorage.setItem("user", JSON.stringify(this.form))  //记住密码
                }
                if (data.userInfo.id) {
                    this.$router.push('/window')
                }
            })
        },
        // getPermiss(id) {
        //     this.ajax.get('/userResource/getCurResoures').then(data => {
        //         sessionStorage.setItem('permiss', JSON.stringify(data))
        //         console.log(data)
        //         this.$router.push('/window')
        //     })
        // }
    }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.main {
    position: absolute;
    width: 100%;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    overflow: auto;
    background-image: url(../assets/login/bg.png);
    background-size: cover;
}
.checkBox {
    width: 80%;
    margin: 0 auto 15px;
    text-align: right;
}
.login {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 25vw;
    min-width: 300px;
    height: 60vh;
    max-height: 450px;
    border-radius: 2px;
    box-shadow: 0 6px 22px 0 rgba(51, 62, 153, 0.7);
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    .el-form {
        text-align: center;
        width: 100%;
        margin: 80px auto;
        .login-title {
            margin-bottom: 60px;
            font-size: 22px;
            color: rgb(56, 53, 53);
            letter-spacing: 0.25px;
            font-weight: bold;
        }
        button {
            line-height: 50px;
            height: 50px;
            color: #fff;
            width: 80%;
            background: rgb(30, 150, 180);
            border-radius: 4px;
            font-size: 16px;
            letter-spacing: 0.18px;
        }
        button:hover {
            cursor: pointer;
        }
        .inputCSS ::v-deep .el-input__inner {
            border: 1px solid rgb(138, 192, 206);
            height: 50px;
            font-size: 16px;
            border-radius: 4px;
            width: 80%;
        }
    }
}

.copyright {
    text-align: center;
    position: absolute;
    bottom: 20px;
    font-size: 12px;
    color: #fff;
    width: 100%;
}
.mb50 {
    margin-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/page/login.vue